import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import TextTruncate from 'react-text-truncate';

/**
 * A wrapper component which provides the ability to truncate text. Combines the <TextTruncate> and <Measure> component in order to create a functional text truncation component.
 *
 * We need to use a wrapper component like this in order to force the <TextTruncate>
 * component to re-render and properly display the truncated text.
 *
 * @class TruncateText
 */
class TruncateText extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: 0
		};

		this.onResize = this.onResize.bind(this);
	}

	onResize(contentRect) {
		this.setState({
			width: contentRect.bounds.width
		});
	}

	render() {
		return (
			<Measure bounds onResize={this.onResize}>
				{({ measureRef }) => (
					<div ref={measureRef}>
						<TextTruncate
							line={this.props.line}
							truncateText={this.props.truncateText}
							text={this.props.text}
							textTruncateChild={this.props.textTruncateChild}
							{...this.props}
						/>
					</div>
				)}
			</Measure>
		)
	}
}

TruncateText.defaultProps = {
	line: 1,
	truncateText: '...'
};

TruncateText.propTypes = {
	line: PropTypes.number.isRequired,
	text: PropTypes.string.isRequired
};

export default TruncateText;



// WEBPACK FOOTER //
// ./src/react/views/generic/TruncateText.jsx